import { CommonModule } from '@angular/common';
import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, NgForm } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, Router} from '@angular/router';
import { catchError, finalize, throwError } from 'rxjs';
import { HttpService } from 'src/app/services/http.service';
import { StateService } from 'src/app/services/state.service';
import { UserService } from 'src/app/services/user.service';
import { UtilService } from 'src/app/services/util.service';
import {SidebarService} from "../../services/sidebar.service";

@Component({
    selector: 'app-update-info',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    standalone: false
})
export class ChangePasswordComponent implements OnInit {
  @ViewChild('fUpdateInfo', { read: NgForm }) fUpdateInfoForm!: NgForm;
  isLoading = false;
  oldPassword!: any;
  newPassword!: any;
  confirmPassword!: any;
  expired: boolean = false;
  newUser: boolean = false;

  constructor(private userService: UserService, private httpService: HttpService, private util: UtilService,
              private stateService: StateService, private activatedRoute: ActivatedRoute, public sidebarService:SidebarService,
              private router: Router) {
  }
  ngOnInit(): void {
    const pwdType = this.activatedRoute.snapshot.params['pwdType'];
    if(pwdType == 'new'){
      this.newUser = true;
    } else if(pwdType == 'expired'){
      this.expired = true;
    }
    if(this.expired || this.newUser){
      this.sidebarService.toggle(false);
      this.sidebarService.enabled = false;
    }
  }

  onUpdateInfo(formData: any) {
    this.isLoading = true;
    let request = {}
    let url = '/change-password'
    if(this.newUser){
      request = {
        user_id: this.stateService.user.user_Id
      }
    } else{
      request = {
        user_id: this.stateService.user.user_Id,
        address1: this.stateService.user.address1,
        city: this.stateService.user.city,
        country: this.stateService.user.country,
        email: this.stateService.user.email,
        epds_role_id: this.stateService.user.role_id,
        faxNo: this.stateService.user.fax_No,
        firstName: this.stateService.user.first_Name,
        lastName: this.stateService.user.last_Name,
        nameOfFirm: this.stateService.user.firm_Name,
        phoneNo: this.stateService.user.phone_No,
        state: this.stateService.user.state,
        zipCode: this.stateService.user.zip_Code
      }
    }
    if (this.expired || this.newUser) {
      url = '/user/update-profile/N'
      request = { ...request,
        password: this.util.base64UrlEncode(this.newPassword),
        retypepassword: this.util.base64UrlEncode(this.newPassword)
      }
    } else {
      request = {...request,
        newPassword: this.util.base64UrlEncode(this.newPassword),
        oldPassword: this.util.base64UrlEncode(this.oldPassword)
      };
    }
    const params = this.httpService.createHttpParams(request);
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const options = { ...headers };
    this.httpService.Post(url, params, options).pipe(
      finalize(() => { this.isLoading = false }),
      catchError(err => {
        this.util.displayDialogMessage("Error", "Failed to update password");
        return throwError(err);
      })
    ).subscribe(response => {
      if (response) {
        this.fUpdateInfoForm.form.reset();
        if (this.expired || (this.newUser && this.stateService.user.role_id == 1)) {
          this.sidebarService.enabled = true;
          this.sidebarService.toggle(true);
        }
        if (this.newUser && this.stateService.user.role_id == 6) {
          this.util.displayDialogMessage('Success', 'You have successfully updated your password. Please update security questions')
            .subscribe(res => {
              this.router.navigate(['/user/change-sec-q/new']);
            });
        } else {
          this.util.displayDialogMessage('Success', 'You have successfully updated your password.');
        }
      }
    });
  }

  passwordInvalidData: [] | undefined;
  handlePasswordInvalidEvent(data: any) {
    this.passwordInvalidData = data;
  }
}
